<template>
  <div class="campaignReport">
    <div class="campaignReport__header">
      <div class="campaignReport__header__title">
        <h1 class="medium-title">Measurement Report</h1>
      </div>
      <div class="campaignReport__header__menu">
        <ul>
          <router-link tag="li" :to="{ name: 'traffic', query: { id: this.routeID, campaign_id: this.campaignID } }">Traffic</router-link>
          <router-link tag="li" :to="{ name: 'impact', query: { id: this.routeID, campaign_id: this.campaignID } }">Impact</router-link>
        </ul>
      </div>
    </div>
    <router-view/>
    <div class="impact">
      <div v-if="!isLoading" class="impact__content">
        <div class="impact__content--left">
          <div class="impact__content__campaignDetail">
            <div class="header title">
              <span class="subhead strong">Upload Report</span>
            </div>
            <div class="impact__content__campaignDetail__field__upload">
              <div class="div-wrapper">
                <div class="left">
                  <input type="file" accept=".pdf, .ppt, .pptx" @change="getFile"
                  ref="fileUpload" style="display: none;">
                  <button
                    type="button"
                    :class="['secondary', 'btn-small', 'btn-checkout-large', isSaving ? 'disabled' : '']"
                    @click="launchFilePicker">
                    Upload File
                  </button>
                </div>
                <div class="right">
                  <label v-if="impactFileName" class="label">{{impactFileName}}</label>
                  <label v-else class="label">Upload file here (.pdf / .ppt / .pptx)</label><br/>
                  <i v-if="impactFileName" @click="cancelFile()" class="adx-ic_cancel"></i>
                </div>
              </div>
            </div>
          </div>
          <button class="btn-large primary button" @click="save">Save</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-traffic',
  components: {
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      impactFile : null,
      impactFileName: '',
      impactFileData: null,
      routeID: null,
      campaignID: null,
      report_id: null

    }
  },
  computed: {

  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    if(this.$route.query.id){
      this.routeID = this.$route.query.id
    } 
    if(this.$route.query.campaign_id){
      this.campaignID = this.$route.query.campaign_id
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    getFile(event){
      // this.$refs.fileUpload.click();
      let input = event.target;

      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.impactFile = e.target.result
        }
        reader.readAsDataURL(input.files[0]);
        this.impactFileName = input.files[0].name
        this.impactFileData = input.files[0]
      }
    
    },
    cancelFile(){
      this.impactFileName= ''
    },
    save(){
      (async () => {
        const file = {
          impact_file: this.impactFileData
        }
        let fileimpact = new FormData();

        fileimpact = obj2fd(file)

        const response = await api.patch(apiV2.measurementImpact(this.routeID), fileimpact, {needToken: true})
        if(this.impactFileName != '') {
          if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Save success',
              text: 'Data successfully saved!',
              type: 'success'
              });
          }
        } else {
          this.$notify({
               group: 'saved',
               title: 'Save error',
               text: 'Oops data can not be saved!',
               type: 'danger'
              });
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>